"use strict";

exports.__esModule = true;
exports.snapgeneToJson = exports.sbolXmlToJson = exports.parseUracilFeatures = exports.jsonToJsonString = exports.jsonToGenbank = exports.jsonToFasta = exports.jsonToBed = exports.geneiousXmlToJson = exports.genbankToJson = exports.fastaToJson = exports.convertBasePosTraceToPerBpTrace = exports.cleanUpTeselagenJsonForExport = exports.anyToJson = exports.ab1ToJson = void 0;

var _anyToJson = _interopRequireDefault(require("./anyToJson"));

exports.anyToJson = _anyToJson["default"];

var _fastaToJson = _interopRequireDefault(require("./fastaToJson"));

exports.fastaToJson = _fastaToJson["default"];

var _genbankToJson = _interopRequireDefault(require("./genbankToJson"));

exports.genbankToJson = _genbankToJson["default"];

var _sbolXmlToJson = _interopRequireDefault(require("./sbolXmlToJson"));

exports.sbolXmlToJson = _sbolXmlToJson["default"];

var _geneiousXmlToJson = _interopRequireDefault(require("./geneiousXmlToJson"));

exports.geneiousXmlToJson = _geneiousXmlToJson["default"];

var _jsonToGenbank = _interopRequireDefault(require("./jsonToGenbank"));

exports.jsonToGenbank = _jsonToGenbank["default"];

var _ab1ToJson = _interopRequireWildcard(require("./ab1ToJson"));

exports.ab1ToJson = _ab1ToJson["default"];
exports.convertBasePosTraceToPerBpTrace = _ab1ToJson.convertBasePosTraceToPerBpTrace;

var _jsonToFasta = _interopRequireDefault(require("./jsonToFasta"));

exports.jsonToFasta = _jsonToFasta["default"];

var _snapgeneToJson = _interopRequireDefault(require("./snapgeneToJson"));

exports.snapgeneToJson = _snapgeneToJson["default"];

var _jsonToBed = _interopRequireDefault(require("./jsonToBed"));

exports.jsonToBed = _jsonToBed["default"];

var _cleanUpTeselagenJsonForExport = _interopRequireDefault(require("./utils/cleanUpTeselagenJsonForExport"));

exports.cleanUpTeselagenJsonForExport = _cleanUpTeselagenJsonForExport["default"];

var _parseUracilFeatures = _interopRequireDefault(require("./utils/parseUracilFeatures"));

exports.parseUracilFeatures = _parseUracilFeatures["default"];

var _jsonToJsonString = _interopRequireDefault(require("./jsonToJsonString"));

exports.jsonToJsonString = _jsonToJsonString["default"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }